
export default function Comparison() {
  const comparisonData = [
    {
      category: '月額料金',
      companyA: '20万円',
      companyB: '15万円',
      ourCompany: '20万円'
    },
    {
      category: '申請書作成',
      companyA: '無料（年間3回まで）',
      companyB: '有料（1件5万円）',
      ourCompany: '完全無料（回数無制限）'
    },
    {
      category: '成功報酬',
      companyA: '10%〜20%',
      companyB: '15%',
      ourCompany: '0%（自社申請の場合）'
    },
    {
      category: '法務サポート',
      companyA: '対応なし',
      companyB: '別途費用',
      ourCompany: '顧問価格で対応'
    },
    {
      category: 'LP制作',
      companyA: '対応なし',
      companyB: '対応なし',
      ourCompany: '5万円で対応'
    },
    {
      category: '集客支援',
      companyA: '提供なし',
      companyB: '提供なし',
      ourCompany: '補助金と連動した集客戦略'
    },
    {
      category: '顧客向け申請代行',
      companyA: '対応なし',
      companyB: '対応なし',
      ourCompany: '月2件まで対応'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            <span className="text-blue-900">他社との比較</span>
          </h3>
          <p className="text-lg text-gray-600">
            TOKANは、補助金申請、法務、LP制作をまとめて扱う<br />
            <strong className="text-blue-900">日本でも数少ない一気通貫型</strong>のサービスです
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse bg-white shadow-xl rounded-2xl overflow-hidden">
            <thead>
              <tr className="bg-gradient-to-r from-blue-900 to-blue-700">
                <th className="py-6 px-6 text-left text-white font-bold text-lg border-r border-blue-600">
                  比較項目
                </th>
                <th className="py-6 px-6 text-center text-white font-bold text-lg border-r border-blue-600">
                  A社
                </th>
                <th className="py-6 px-6 text-center text-white font-bold text-lg border-r border-blue-600">
                  B社
                </th>
                <th className="py-6 px-6 text-center text-white font-bold text-lg bg-gradient-to-r from-orange-500 to-orange-600">
                  <div className="flex items-center justify-center gap-2">
                    <i className="ri-star-fill text-yellow-300"></i>
                    <span>TOKAN</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => (
                <tr 
                  key={index}
                  className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-blue-50 transition-colors`}
                >
                  <td className="py-5 px-6 font-bold text-gray-900 border-r border-gray-200">
                    {row.category}
                  </td>
                  <td className="py-5 px-6 text-center text-gray-700 border-r border-gray-200">
                    {row.companyA}
                  </td>
                  <td className="py-5 px-6 text-center text-gray-700 border-r border-gray-200">
                    {row.companyB}
                  </td>
                  <td className="py-5 px-6 text-center font-bold text-blue-900 bg-orange-50">
                    <div className="flex items-center justify-center gap-2">
                      <i className="ri-check-double-line text-green-500"></i>
                      <span>{row.ourCompany}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-12 bg-white rounded-2xl p-8 shadow-lg">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-blue-900 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-lightbulb-flash-line text-yellow-400 text-2xl"></i>
            </div>
            <div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">TOKANの最大の強み</h4>
              <p className="text-gray-700 leading-relaxed">
                補助金代行会社は法務ができず、LP制作会社は補助金が分からず、一般の行政書士はLPが作れません。<br />
                <strong className="text-blue-900">これらの要素をすべて統合して提供できることが、TOKANの最大の価値です。</strong><br />
                補助金を取るだけでなく、法務リスクを減らし、売上増加にも直結する導線を設計できます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
